import './TeamMemberList.scss';
import Component from './TeamMemberList.js';
export default Component;